import React, { useState, useEffect } from "react";

import { getsitedata } from "./../action/user";
import footerCallIcon from '../../assests/images/footer-call-icon.png';
import footerMsgIcon from '../../assests/images/footer-msg-icon.png';
import footerLogo from '../../assests/images/kalyana-saptha-pathi-logo.png';
import {
    Link
} from "react-router-dom";

function Footer() {

    const [sites, setSites] = useState([])
    const getPieData = async () => {
        var test = await getsitedata();
        setSites(test.userValue[0]);
        //   console.log(test, "bird");


    }

    useEffect(() => {
        //logout(history)
        getPieData();
    }, []);

    return (
        <div>
            <style jsx>{`
            .matrimonylogo{
                max-width: 240px; 
                height: auto;     
                object-fit: contain;  
                display: block; 
                margin-left:10px;
                padding-top:10px;
              }
              `}
            </style>

            <div class="container-fluid p-4 footer-bg">
                <div class="container-min">
                    <div class="row text-center">
                        <div class="col-md-12 col-12 mx-auto pt-3 xs-padd0">
                            <div class="row mt-4 xs-mt0">
                                <div class="col-md-4 col-12 text-left footer-width">
                                    <div class="footer-links" style={{ paddingLeft: '20px' }}>
                                        {/* <Link className="" to="/">Home
                                        </Link> */}
                                        <a href="/" rel="noreferrer">Home</a> <br />
                                        <a href="/about" rel="noreferrer">About Us</a> <br />
                                        {/* <a href="/services" rel="noreferrer">Services</a> <br /> */}
                                        <a href="/contact" rel="noreferrer">Contact us</a> <br />
                                        <a href="/terms" target="_blank" rel="noreferrer">Terms &amp; Conditions</a>
                                    </div>
                                </div>
                                <div class="col-md-4 col-12 text-left footer-width">
                                    <div class="footer-links" style={{ paddingLeft: '20px' }}>
                                        <a href="/privacy" rel="noreferrer">Privacy Policy</a> <br />
                                        <a href="/cancellation" rel="noreferrer">Cancellation and Refund Policy</a> <br />
                                        <a href="/payment" rel="noreferrer">Kalyana Sapthapathi Packages</a>
                                    </div>
                                </div>
                                <div class="col-md-4 col-12 text-left">
                                    <div class="footer-links" style={{ paddingLeft: '20px', borderRight: '0' }}>
                                        <a href="tel: +91 936 397 7777"><img src={footerCallIcon} class="mr-2" style={{ marginRight: '5px' }} alt="Footer call icon" />  +91 96529 66888</a> <br />
                                        <a href="mailto:kalyanasapthapadhi@gmail.com" rel="noreferrer"><img src={footerMsgIcon} class="mr-2" style={{ marginRight: '5px' }} alt="Footer message icon" /> kalyanasapthapadhi@gmail.com</a> <br />
                                        <a href="/" rel="noreferrer">
                                            <img src={footerLogo} class="matrimonylogo" alt="Matrimony footer logo" style={{ marginTop:'10px' }} />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="col mt-4 xs-mt0">
                                <div class="col-md-11 col-12 mx-auto pt-3 d-flex justify-content-between align-items-center">
                                    <span class="copyright-text text-align-left" style={{ paddingTop: '20px' }}>
                                        Copyright@ 2025 Kalyana Sapthapadhi. All rights reserved.
                                    </span>
                                    <a href="https://lycoris.in/" target="_blank" className="abcd" style={{ paddingTop: '20px' }}>
                                        Design & Developed By Lycoris Ads & Software Solutions Pvt Ltd
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    )
}
export default Footer;